import { useContext } from 'react';
import { createContext } from 'react';

import { SearchTitleV2Props } from '../@types/SearchTitleV2Props';

export const SearchTitleV2Context = createContext<SearchTitleV2Props>({} as SearchTitleV2Props);

SearchTitleV2Context.displayName = 'SearchTitleV2';

const SearchTitleV2Provider = (props: SearchTitleV2Props) => (
	<SearchTitleV2Context.Provider value={props}>{props.children}</SearchTitleV2Context.Provider>
);

export const useSearchTitleV2 = () => {
	const context = useContext(SearchTitleV2Context);

	return context;
};

export default SearchTitleV2Provider;
